// library imports
import { useSelector } from "react-redux";

// styles imports
import './LayoutElement.scss';

const PageHeader = (props) => {
    const { scene, parts, isHeader, headerText } = useSelector((store) => store.scene);
    return (
        <div className={"page-header " + (isHeader ? "isHeader" : "")}>
            <div className='page-header-container'>
                {props.children}
            </div>
        </div>
    );
};

export default PageHeader;